var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddImageWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.5C20.7366 40.5 17.5465 39.5323 14.8331 37.7192C12.1197 35.9062 10.0048 33.3293 8.75599 30.3143C7.50715 27.2993 7.18039 23.9817 7.81705 20.781C8.45371 17.5803 10.0252 14.6403 12.3327 12.3327C14.6403 10.0252 17.5803 8.45371 20.781 7.81705C23.9817 7.18039 27.2993 7.50715 30.3143 8.75599C33.3293 10.0048 35.9062 12.1197 37.7192 14.8331C39.5323 17.5465 40.5 20.7366 40.5 24C40.5 28.3761 38.7616 32.5729 35.6673 35.6673C32.5729 38.7616 28.3761 40.5 24 40.5ZM24 10.5C21.33 10.5 18.7199 11.2918 16.4998 12.7752C14.2797 14.2586 12.5494 16.367 11.5276 18.8338C10.5059 21.3006 10.2385 24.015 10.7594 26.6337C11.2803 29.2525 12.5661 31.6579 14.4541 33.5459C16.3421 35.434 18.7475 36.7197 21.3663 37.2406C23.985 37.7615 26.6994 37.4942 29.1662 36.4724C31.633 35.4506 33.7414 33.7203 35.2248 31.5002C36.7082 29.2801 37.5 26.67 37.5 24C37.5 20.4196 36.0777 16.9858 33.5459 14.4541C31.0142 11.9223 27.5804 10.5 24 10.5Z",
    fill: "#none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4985 22.4995H25.4985V16.4995H22.4985V22.4995H16.4985V25.4995H22.4985V31.4995H25.4985V25.4995H31.4985V22.4995Z",
    fill: "#none"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImageWorkspace);
export default __webpack_public_path__ + "static/media/addImageWorkspace.e44a4530.svg";
export { ForwardRef as ReactComponent };